/**
 * Feed calculation helpers.
 *
 * These helpers are separated from NotEnoughFeedDialog.tsx
 * to enable Fast Refresh. Non-component exports in the same file as components
 * break HMR.
 */

import { GENERAL_FEED_TYPE, GENERAL_FEED_UNITS, GeneralFeed } from "model";

export function sumFeedForType(
  feeds: GeneralFeed[] | undefined,
  feedTypeEnum: GENERAL_FEED_TYPE
) {
  let sumAmount = 0;
  if (feeds) {
    for (const feed of feeds.filter(
      (feed: GeneralFeed) => feed.feedType === feedTypeEnum
    )) {
      sumAmount =
        feed.amount * (feed.unitType === GENERAL_FEED_UNITS.TONNE ? 1000 : 1) +
        sumAmount;
    }
  }
  return sumAmount;
}
